var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getRouteBaseName() === 'magazine-article' && _vm.$store.state.blog.doesProgressBarHaveTransition)?_c('div',{staticClass:"absolute w-full h-1 bottom-0 left-0 bg-grey-100"},[_c('div',{staticClass:"absolute bottom-0 left-0 h-1 bg-yellow-100 transition-all",style:(`width: ${_vm.blogArticleReadProgressPercentile}%`)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }